import "./ProposalEndClientDetailPageLeftSection.scss"
import parse from "html-react-parser"
import { useEffect, useState } from "react"
import DeliverableCard from "./detail-page-sections/components/deliverable-card/DeliverableCard"
import { gsap } from "../../../../helper/gsap.default"
import ObjectiveCard from "./detail-page-sections/components/objective-card/ObjectiveCard"
import { MEDIA_TYPES_FOR_END_CLIENT } from "../../../../layouts/proposal-template/ProposalTemplateEndClient.config"

export function ApproachLeftSection({ data: approachContent }) {
  const { infographic, paragraphText, deliverables = [] } = approachContent
  const [isError, setIsError] = useState(null);
  if (deliverables.length === 0) {
    return <h2 className="text-white text-center pt-8 mt-8 h-full w-full">Deliverables are empty. Please validate Data in Curated.</h2>
  }

  const handleMediaType = (type, deliverable) => {
    let link = null;
    const typeData = deliverable?.mediaData;
    if (type === MEDIA_TYPES_FOR_END_CLIENT.VIDEO) {
      link = typeData?.video?.url
    }
    else if (type === MEDIA_TYPES_FOR_END_CLIENT.LINK) {
      link = typeData?.link
    }
    else if (type === MEDIA_TYPES_FOR_END_CLIENT.DOCUMENT) {
      link = typeData?.pdfFile?.url
    }
    else if (type === MEDIA_TYPES_FOR_END_CLIENT.IMAGES) {
      link = typeData?.images
    }

    if (!link) {
      setIsError(true);
    }
    return { link }
  }

  if (isError) {
    return <h2 className="text-white text-center pt-8 mt-8">Improper Data. Please validate data in Curated.</h2>
  }
  return (
    <div className='ApproachLeftSection flex  justify-content-center h-full w-full pl-8 pr-8 pt-7'>
      <div className="Container mb-4">
        <div className="Container mb-4">
          <div className="Heading uppercase text-lg font-semibold mb-4">APPROACH</div>
          {parse(paragraphText)}

          <div className="flex justify-content-center mt-5 w-full">
            <img src={infographic} className="w-full" />
          </div>
          <div className="SecondaryHeading Heading uppercase text-lg font-semibold mt-7">EXPECTED DELIVERABLE OUTPUT</div>
          <div className="CardSection mt-4 pb-5 grid gird-nogutter ">
            {deliverables.map(deliverable => {
              let { link } = handleMediaType(deliverable?.mediaData.type, deliverable)
              const type = deliverable.mediaData.type
              const headingText = deliverable.data.headingText
              const backgroundImage = deliverable.data.backgroundImage.url
              return (
                <div className="col-6 ">
                  <DeliverableCard type={type} imgUrl={backgroundImage} link={link} headingText={headingText} />
                </div>
              )
            })}
          </div>
        </div>
      </div >
    </div>
  )
}



export function ObjectiveCardSection({ data }) {
  let { cards:objectiveCards } = data
  useEffect(() => {
    gsap.fromTo(".Card", {
      y: 200,
      opacity: 0,
    }, {
      y: 0,
      opacity: 1,
      duration: 1,
      stagger: .2,
      ease: "none",
      scrollTrigger: {
        trigger: ".Container",
        start: "top center"
      }
    })
  }, [])

  return (
    <div className="ObjectiveCardSection px-8 pt-6">
      <div className="Container">
        <div className="Heading uppercase text-lg font-semibold mb-4">RESEARCH OBJECTIVE</div>
        <div className="grid mt-5 grid-nogutter">
          {
            objectiveCards.map((card, idx) => (
              <div className="col-6 px-4 py-3 my-2 Card">
                <ObjectiveCard className="h-full" heading={card.heading} content={card.descriptionText} count={idx + 1} />
              </div>
            ))
          }
        </div>
      </div>
    </div>
  )
}

export function BackgroundTextArea({ data: { backgroundText } }) {
  return (
    <div className='BackgroundTextArea flex  h-full w-full px-8 pt-7'>
      <div className="Container">
        <div className="Heading uppercase text-lg font-semibold mb-4">background</div>
        {parse(backgroundText)}
      </div>
    </div>
  )
}
